import React, { memo } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { MenuIcon } from 'transfix-icons'

const useMenuButtonStyles = makeStyles({
  root: {
    display: 'flex',
    width: 'auto',
    color: brandColors.coolGray8,
  },
  icon: {
    marginTop: -1,
    width: 'auto',
    maxHeight: 22,
    maxWidth: 27,

    '& svg': {
      width: 27,
    },
  },
})

export const MenuButton = memo(() => {
  const classes = useMenuButtonStyles()
  return (
    <Box className={classes.root}>
      <MenuIcon size='large' className={classes.icon} />
    </Box>
  )
})
